import {
  GET_CONVERSATIONS_REQUEST,
  GET_CONVERSATIONS_SUCCESS,
  GET_CONVERSATIONS_FAILURE,
  GET_CONVERSATION_DETAILS_REQUEST,
  GET_CONVERSATION_DETAILS_SUCCESS,
  GET_CONVERSATION_DETAILS_FAILURE,
  GET_CONVERSATION_LIST_REQUEST,
  GET_CONVERSATION_LIST_SUCCESS,
  GET_CONVERSATION_LIST_FAILURE,
} from '../actions/conversationsActions';

const initialState = {
  conversations: [],
  loading: false,
  loadingMore: false,
  error: null,
  pagination: {
    nextCursor: null,
    hasMore: false,
    totalConversations: 0,
    page: 1,
    limit: 50
  },
  summary: null,
  conversationDetails: null,
  detailsLoading: false,
  detailsError: null
};

const conversationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONVERSATIONS_REQUEST: {
      const append = action.meta?.append;
      return {
        ...state,
        loading: append ? state.loading : true,
        loadingMore: append ? true : false,
        error: null,
      };
    }

    // Page/limit list API
    case GET_CONVERSATION_LIST_REQUEST: {
      const append = action.meta?.append;
      return {
        ...state,
        loading: append ? state.loading : true,
        loadingMore: append ? true : false,
        error: null,
      };
    }

    case GET_CONVERSATION_LIST_SUCCESS: {
      const newItems = action.payload?.data?.conversations || [];
      const paginationData = action.payload?.data?.pagination || {};
      const summaryData = action.payload?.data?.summary || null;
      return {
        ...state,
        loading: false,
        loadingMore: false,
        conversations: newItems,
        summary: summaryData,
        pagination: {
          ...state.pagination,
          page: paginationData.currentPage || 1,
          limit: paginationData.limit || 10,
          hasMore: paginationData.hasNextPage || false,
          totalConversations: paginationData.totalCount || 0,
          totalCount: paginationData.totalCount || 0,
          totalPages: paginationData.totalPages || 0,
          currentPage: paginationData.currentPage || 1,
          nextCursor: null,
        },
        error: null,
      };
    }

    case GET_CONVERSATION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        error: action.error,
        conversations: [], // Clear conversations on API failure
        summary: null, // Clear summary on API failure
        pagination: {
          ...state.pagination,
          totalCount: 0,
          totalPages: 0,
          currentPage: 1,
          hasNextPage: false,
          hasPrevPage: false,
        },
      };

    case GET_CONVERSATIONS_SUCCESS: {
      const newItems = action.payload.data?.conversations || [];
      const append = action.meta?.append;
      const merged = append ? [...state.conversations, ...newItems] : newItems;
      return {
        ...state,
        loading: false,
        loadingMore: false,
        conversations: merged,
        pagination: {
          nextCursor: action.payload.data?.pagination?.nextCursor || null,
          hasMore: action.payload.data?.pagination?.hasMore || false,
          totalConversations: action.payload.data?.pagination?.totalConversations || (append ? state.pagination.totalConversations : 0)
        },
        error: null,
      };
    }

    case GET_CONVERSATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        error: action.error,
      };

    case GET_CONVERSATION_DETAILS_REQUEST:
      return {
        ...state,
        detailsLoading: true,
        detailsError: null,
      };

    case GET_CONVERSATION_DETAILS_SUCCESS:
      return {
        ...state,
        detailsLoading: false,
        conversationDetails: action.payload,
        detailsError: null,
      };

    case GET_CONVERSATION_DETAILS_FAILURE:
      return {
        ...state,
        detailsLoading: false,
        detailsError: action.error,
        // Preserve existing conversation details - don't reset to null
      };

    default:
      return state;
  }
};

export default conversationsReducer;
